"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSignOutRequest = void 0;
const utils_1 = require("../utils");
const handleSignOutRequest = ({ oAuthConfig, userPoolClientId, origin, setCookieOptions, }) => {
    const urlSearchParams = new URLSearchParams({
        client_id: userPoolClientId,
        logout_uri: (0, utils_1.resolveRedirectSignOutUrl)(origin, oAuthConfig),
    });
    const headers = new Headers();
    headers.set('Location', (0, utils_1.createLogoutEndpoint)(oAuthConfig.domain, urlSearchParams));
    (0, utils_1.appendSetCookieHeaders)(headers, (0, utils_1.createSignOutFlowProofCookies)(), (0, utils_1.createAuthFlowProofCookiesSetOptions)(setCookieOptions, origin));
    return new Response(null, {
        status: 302,
        headers,
    });
};
exports.handleSignOutRequest = handleSignOutRequest;
